import { render, staticRenderFns } from "./Gvnt.vue?vue&type=template&id=24e0c44c&scoped=true&"
import script from "./Gvnt.vue?vue&type=script&lang=js&"
export * from "./Gvnt.vue?vue&type=script&lang=js&"
import style0 from "./Gvnt.vue?vue&type=style&index=0&id=24e0c44c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0c44c",
  null
  
)

export default component.exports